import React, { Fragment,Component } from 'react';

import sceneImg from './image/company-scene.jpg';
import quote1 from './image/quote-start.svg';
import quote2 from './image/quote-end.svg';
import slogan from './image/slogan-about.svg';
import banner from './image/banner-about.svg';
import banner_mengduo from './image/mengduo/about.svg'

import './About.css';

export default class About extends Component {

  constructor(props){
    super(props)
    this.state={
    }
  }

  componentDidMount(){
    if(/Android|webOS|iPhone|iPod|pad|ipad/i.test(navigator.userAgent)) {
      this.setState({
        isMobile:!this.state.isMobile
      })
    } 
  }

  render(){
    return(
      <Fragment>
        {this.state.isMobile&&
        <Fragment >
          <div style={{textAlign:"center"}}>
          <div  style={{margin:"8rem 0 3rem 0",padding:"0 2rem 0 2rem",textAlign:"left"}}>
              <img
                style={{width:"1.5rem"}}
                src={quote1}
                alt=""
              />
              <div className="AboutUs--content__title">新技术  •  新零售  •  新生态</div>
              <p className="AboutUs--content__desc">
                青岛红创众投科技发展有限公司（简称红创科技），是一家以人工智能为发力点的软件高科技企业，在机器视觉、自然语言翻译，AR、VR3D呈现领域都有多个成功案例。
              </p>
              <p className="AboutUs--content__desc">
                我公司研发的【智量】是一种能够改变商业模式的前沿科技，我们用户只需用手机拍摄正面、侧面两张照片，经过训练的神经网络会自动识别人体上的关键点，生成完整人体模型，并进行测量胸围、肩宽、身长等30余项数据。
              </p>
              <p className="AboutUs--content__desc">
                核心模型经数百万级图像训练的深度学习算法生成，综合了人体识别，部位标记，关节检测等各种前沿能力。
              </p>
              <p className="AboutUs--content__desc">
                在此基础上，我们研发了全套软硬件解决方案，无论是服装定制店，健身房，私人裁缝。【智量】都可以找到适合你的应用场景。
              </p>
            <img
              style={{width:"1.5rem",position:"absolute",right:"2rem"}}
              src={quote2}
              alt=""
            />
          </div>
          <img src={sceneImg} style={{maxWidth:"20rem",marginTop:"2rem"}}/>
          </div>
        </Fragment>}
        {!this.state.isMobile&&
        <Fragment>
          <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
            <div className="banner--content">
              <img src={slogan} alt="slogan" />
              <img src={global.constants.channel==="mengduo"? banner_mengduo:banner} alt="" />
            </div>
          </div>
          <div className="AboutUs--content content-area">
            <div className="AboutUs--content__wrapper">
              <img
                className="AboutUs--content__quote1"
                src={quote1}
                alt=""
              />
              <p className="AboutUs--content__title">新技术  •  新零售  •  新生态</p>
              <p className="AboutUs--content__desc">
                青岛红创众投科技发展有限公司（简称红创科技），是一家以人工智能为发力点的软件高科技企业，在机器视觉、自然语言翻译，AR、VR3D呈现领域都有多个成功案例。
              </p>
              <p className="AboutUs--content__desc">
                我公司研发的【智量】是一种能够改变商业模式的前沿科技，我们用户只需用手机拍摄正面、侧面两张照片，经过训练的神经网络会自动识别人体上的关键点，生成完整人体模型，并进行测量胸围、肩宽、身长等30余项数据。
              </p>
              <p className="AboutUs--content__desc">
                核心模型经数百万级图像训练的深度学习算法生成，综合了人体识别，部位标记，关节检测等各种前沿能力。
              </p>
              <p className="AboutUs--content__desc">
                在此基础上，我们研发了全套软硬件解决方案，无论是服装定制店，健身房，私人裁缝。【智量】都可以找到适合你的应用场景。
              </p>
              <img
                className="AboutUs--content__quote2"
                src={quote2}
                alt=""
              />
            </div>
            <img
              className="AboutUs--content__scene"
              src={sceneImg}
              alt="real scene"
            />
          </div>
        </Fragment>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/About.js